var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { style: _vm.styleOverride },
    [
      _vm.data.ShowTitle
        ? _c("w-card-title", [_vm._v(_vm._s(_vm.data.Title))])
        : _vm._e(),
      _c("iframe", {
        ref: "frame",
        staticClass: "iframe",
        attrs: { src: _vm.url, frameborder: "0" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }